/** Un afiliado puede venir sólo con apellido —las obras sociales a veces lo
 *  mandan así— o sólo con documento. Condicionar el bloque al nombre de pila
 *  lo hacía desaparecer del detalle y del comprobante. */
export const tieneDatosDeAfiliado = (reserva: {
  afiliado_nombre?: string | null;
  afiliado_apellido?: string | null;
  afiliado_dni?: string | null;
}): boolean =>
  Boolean(
    reserva.afiliado_nombre?.trim() ||
      reserva.afiliado_apellido?.trim() ||
      reserva.afiliado_dni?.trim()
  );

/** Nombre y apellido en una línea, sin espacios sobrantes cuando falta uno. */
export const nombreCompletoAfiliado = (reserva: {
  afiliado_nombre?: string | null;
  afiliado_apellido?: string | null;
}): string =>
  [reserva.afiliado_nombre, reserva.afiliado_apellido]
    .map((parte) => (parte ?? "").trim())
    .filter(Boolean)
    .join(" ");
